import Layout from "../components/Layout";
import Container  from 'react-bootstrap/Container';
function Contact() {
    return (
        <>
            <Layout>
        <Container>

                Contact
        </Container>
            </Layout>
        </>
    );
}

export default Contact;